module.exports = __webpack_public_path__ + "27a84433a36a4168a9ced4a4e2e0cb79.svg";